import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'renci_batch_items'
})
export class BatchItemsPipe implements PipeTransform {

  transform(value: Array<any>, batchedData: any): Array<any> {
    if (value) {
      return value
        .map(x => {
          if (batchedData[x.typeId]) {
            x._isDeleted = batchedData[x.typeId]._isDeleted;
          }
          return x;
        })
        .sort((left: any, right: any) => {
          let l = left.orderSequence;
          const r = right.orderSequence;

          if (batchedData[left.typeId]) {
            l = batchedData[left.typeId].orderSequence;
          }

          if (batchedData[right.typeId]) {
            l = batchedData[right.typeId].orderSequence;
          }
          return l - r;
        });
    } else {
      return value;
    }
  }
}
